import React, { useEffect } from "react";

import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

import TopPages from "./TopPages";
import CampaignCover from "./CampaignCover";
import CampaignSection from "./CampaignSection";
import { Footer, Header } from "../../components";
import { StyledCampaign } from "./CampaignStyles";
import { fundRaiserPageAction } from "../../store/actions";
import CampaignPageListing from "./CampaignPageListing";

export const Campaign = () => {
    const campaignId = window.location.pathname.split("/")[2];
    const campaignDetails = useSelector(state => state.fundraiser_page.campaign_details);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fundRaiserPageAction.getCampaignDetails(campaignId));
    }, [])

    return <StyledCampaign className="App-display-height">
        <Header />
        <Box className="App-content">
            {
                campaignDetails ?
                    <React.Fragment>
                        <CampaignCover />
                        <CampaignSection id="1" heading={campaignDetails?.section1_heading} description={campaignDetails?.section1_description} />
                        {campaignDetails?.show_leaderboard ? <TopPages /> : null}
                        <CampaignSection id="2" heading={campaignDetails?.section2_heading} description={campaignDetails?.section2_description} />
                        {campaignDetails?.show_all_fundraisers ? <CampaignPageListing /> : null}
                    </React.Fragment> :

                    <Box className="Loader"><CircularProgress color="neutral" /></Box>
            }
        </Box>
        <Footer />
    </StyledCampaign>
}